import { topicRanks, topicTags } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

const tagToneStyles: Record<string, string> = {
  hot: "bg-primary-500 text-background-50 border-primary-500",
  accent: "bg-accent-100 text-accent-900 border-accent-200",
  secondary: "bg-secondary-100 text-secondary-900 border-secondary-200",
  plain: "bg-background-50 text-foreground-700 border-background-300",
};

export default function TopicWall() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-100 border-y border-background-200">
      <div className="w-full max-w-site mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="话题 / 标签墙"
          title="正在讨论的话题，按热度排在这里"
          desc="每条帖子都会挂上标签，点进去就是同一个话题下所有人的评论与追更。左边是今日热度榜，右边是可以直接点的标签墙。"
        />

        <div className="mt-9 grid grid-cols-1 lg:grid-cols-3 gap-5">
          <div className="lg:col-span-1 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-base font-bold text-foreground-950">
                今日热度榜
              </h3>
              <span className="inline-flex items-center gap-1 text-xs text-primary-700">
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-fire-line"></i>
                </span>
                实时
              </span>
            </div>
            <ul className="mt-4 divide-y divide-background-200">
              {topicRanks.map((topic) => (
                <li key={topic.rank}>
                  <a href="#comments" className="flex items-start gap-3 py-3 group">
                    <span
                      className={`font-heading text-sm font-bold w-6 shrink-0 ${
                        topic.rank === "01" || topic.rank === "02"
                          ? "text-primary-600"
                          : "text-foreground-400"
                      }`}
                    >
                      {topic.rank}
                    </span>
                    <span className="flex-1 min-w-0">
                      <span className="block text-sm text-foreground-900 truncate group-hover:text-primary-700 transition-colors">
                        {topic.name}
                      </span>
                      <span className="block text-xs text-foreground-500 mt-1">
                        {topic.count}
                      </span>
                    </span>
                    <span className="w-4 h-4 mt-0.5 flex items-center justify-center shrink-0">
                      <i
                        className={
                          topic.trend === "up"
                            ? "ri-arrow-up-line text-primary-600"
                            : topic.trend === "down"
                            ? "ri-arrow-down-line text-secondary-600"
                            : "ri-subtract-line text-foreground-400"
                        }
                      ></i>
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2 rounded-lg border border-background-200 bg-background-50 p-4 md:p-6">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <h3 className="font-heading text-base font-bold text-foreground-950">
                标签墙
              </h3>
              <button
                type="button"
                className="h-9 px-4 rounded-md border border-background-300 bg-background-50 text-xs md:text-sm text-foreground-800 inline-flex items-center gap-1.5 hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-refresh-line"></i>
                </span>
                换一批
              </button>
            </div>

            <div className="mt-5 flex flex-wrap gap-2.5">
              {topicTags.map((tag) => (
                <a
                  key={tag.name}
                  href="#comments"
                  className={`inline-flex items-center gap-2 px-3.5 py-2 rounded-full border text-xs md:text-sm transition-colors ${
                    tagToneStyles[tag.tone] ?? tagToneStyles.plain
                  }`}
                >
                  <span>{tag.name}</span>
                  <span className="text-[11px] opacity-75">{tag.count}</span>
                </a>
              ))}
            </div>

            <div className="mt-6 pt-5 border-t border-background-200 grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div>
                <p className="font-heading text-lg font-bold text-foreground-950">16</p>
                <p className="text-xs text-foreground-500 mt-1">今日新增标签</p>
              </div>
              <div>
                <p className="font-heading text-lg font-bold text-foreground-950">214</p>
                <p className="text-xs text-foreground-500 mt-1">本周活跃话题</p>
              </div>
              <div>
                <p className="font-heading text-lg font-bold text-foreground-950">9.6 万</p>
                <p className="text-xs text-foreground-500 mt-1">标签下累计评论</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}